import React from 'react';
import { useTranslation } from 'react-i18next';
import TurnAroundService from '../../services/turnarounds';
import DeleteConfirmationModal from '../common/modals/DeleteConfirmationModal';

interface DeleteDevicesConfirmProps {
  open: boolean;
  deviceIds: string[];
  turnaroundId: string;
  onClose: () => void;
  onSuccess: (count: number) => void;
}

const DeleteDevicesConfirm: React.FC<DeleteDevicesConfirmProps> = ({
  open,
  deviceIds,
  turnaroundId,
  onClose,
  onSuccess
}) => {
  const { t } = useTranslation();

  const handleDeleteConfirm = async (items: Array<{ id: string; name: string }>,userId: string='') => {
    const turnAroundService = new TurnAroundService();
    await turnAroundService.deleteDevicesFromTurnaround(turnaroundId, items.map((item:any) => item.id));
  };

  // Convert deviceIds to items with placeholder names since we don't have actual device names
  const items = deviceIds.map(id => ({ id, name: `Device ${id.slice(-8)}` }));

  return (
    <DeleteConfirmationModal
      open={open}
      onClose={onClose}
      onConfirm={handleDeleteConfirm}
      onSuccess={onSuccess}
      title={t('deleteDevicesTitle', 'Remove Devices')}
      items={items}
      itemType="device"
      showList={false}
    />
  );
};

export default DeleteDevicesConfirm;
